import { type MetaFunction } from '@remix-run/node'
import preferredmutual from './preferredmutual.png'

export const meta: MetaFunction = () => [
	{ title: 'Preferred Mutual Insurance Company' },
	{
		name: 'description',
		content: 'We offer insurance from Preferred Mutual Insurance Company.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Preferred Mutual</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img
					src={preferredmutual}
					alt="Preferred Mutual Insurance Company"
					className="w-64"
				/>

				<h3>History</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Preferred Mutual was founded in 1896 by Frank E. Holmes. He modeled
					the company after the first insurance company in the US, started by
					Benjamin Franklin. As the name suggests, Preferred Mutual is a mutual
					company, which means that the company is owned by the policyholders.
					As a mutual company, they can offer broader coverage at a lower cost,
					since there are no stockholders involved.
				</p>
				<h3>Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					A.M. Best gave Preferred Mutual a financial strength rating of "A"
					(Excellent).
				</p>
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Preferred offers a line of very competitively priced homeowners, auto,
					and umbrella products. The commercial product line is tailored to fit
					a variety of contractors, businesses and religious institutions. In
					addition, commercial automobile and umbrella policies to fit most
					cases.
				</p>
				<h3>Service</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Claim service is high on the list of achievements that Preferred
					Mutual is proud of. A 2009 satisfaction ranking of #11 for all
					automobile insurance companies in NY state is evidence of the
					professionalism and fairness of the claim staff.
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://www.preferredmutual.com"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://www.preferredmutual.com/ (opens in a new tab)
					</a>
				</p>
				<h3>Claims</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					(800) 333-7642
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="Preferred Mutual Online Payment"
						href="https://preferredmutual.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://preferredmutual.com/ (opens in a new tab)
					</a>
					<br />
					<br />
					Billing Address:
					<br />1 Preferred Way
					<br />
					New Berlin, NY 13411-1896
				</p>
			</p>

			<section>
				<h3>Home Office Address</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Preferred Mutual Insurance Company
					<br />
					1 Preferred Way
					<br />
					New Berlin, NY 13411-1896
				</p>
			</section>
		</main>
	)
}
